import React, { useMemo } from 'react';
import { Card, Descriptions, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';
import PhoneNumberDisplay from '../PhoneNumberDisplay';

const { Text } = Typography;

interface ControlAddressCardProps {
  proposal?: any | null;
  loading?: boolean;
  className?: string;
}

const ControlAddressCard: React.FC<ControlAddressCardProps> = ({ proposal, loading = false, className }) => {
  const navigate = useNavigate();

  const descriptionLabelStyle = useMemo<React.CSSProperties>(
    () => ({
      width: 200,
      maxWidth: 200,
      fontWeight: 600,
      color: 'rgba(0, 0, 0, 0.88)',
    }),
    [],
  );

  const descriptionValueStyleNormal = useMemo<React.CSSProperties>(
    () => ({
      color: 'rgba(0, 0, 0, 0.88)',
    }),
    [],
  );

  const formatAddressPart = (value?: string | null): string => {
    const trimmedValue = value?.trim();
    return trimmedValue ? trimmedValue.toLocaleUpperCase('tr-TR') : '-';
  };

  const cardClassName = useMemo(() => ['br-30px', className].filter(Boolean).join(' '), [className]);

  return (
    <>
      {proposal?.address ? (
        <Descriptions column={1} bordered size='small'>
          {proposal?.company?.id && proposal?.company?.name && (
            <Descriptions.Item label='Firma' labelStyle={descriptionLabelStyle}>
              <span
                style={{ cursor: 'pointer', color: '#1677ff' }}
                onClick={() => navigate(`/companies/${proposal.company.id}`)}
                title='Firma detayına git'
              >
                {proposal.company.name}
              </span>
            </Descriptions.Item>
          )}
          <Descriptions.Item label='Adres Başlığı' labelStyle={descriptionLabelStyle}>
            {proposal.address?.latitude != null && proposal.address?.longitude != null ? (
              <a
                href={`https://www.google.com/maps/search/?api=1&query=${proposal.address.latitude},${proposal.address.longitude}`}
                target="_blank"
                rel="noopener noreferrer"
                title="Google Haritalar'da aç"
                style={{ color: '#1677ff', cursor: 'pointer' }}
              >
                {proposal.address.title || '-'}
              </a>
            ) : (
              <span style={descriptionValueStyleNormal}>{proposal.address.title || '-'}</span>
            )}
          </Descriptions.Item>
          <Descriptions.Item label='Adres' labelStyle={descriptionLabelStyle}>
            {proposal.address.addressLine1}  {proposal.address.addressLine2}
          </Descriptions.Item>
          <Descriptions.Item label='İlçe / İl' labelStyle={descriptionLabelStyle}>
            {`${formatAddressPart(proposal.address.state)} / ${formatAddressPart(proposal.address.city)}`}
          </Descriptions.Item>
          <Descriptions.Item label='Telefon' labelStyle={descriptionLabelStyle}>
            {proposal.address.phone ? (
              <PhoneNumberDisplay value={proposal.address.phone} />
            ) : (
              '-'
            )}
          </Descriptions.Item>
          <Descriptions.Item label='E-Posta' labelStyle={descriptionLabelStyle}>
            {proposal.company.email}
          </Descriptions.Item>
                    <Descriptions.Item label='Vergi Dairesi' labelStyle={descriptionLabelStyle}>
            {proposal.company.taxOffice || '-'}
          </Descriptions.Item>
          <Descriptions.Item label='Vergi Numarası' labelStyle={descriptionLabelStyle}>
            {proposal.company.taxNumber || '-'}
          </Descriptions.Item>
          <Descriptions.Item label='SGK/DETSİS Numarası' labelStyle={descriptionLabelStyle}>
            {proposal.address.sgkNumber || '-'}
          </Descriptions.Item>
        </Descriptions>
      ) : (
        <Text>Adres bilgisi bulunamadı.</Text>
      )}
    </>
  );
};

export default ControlAddressCard;
